import { Component, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { GridConfig } from '../../shared/dynamic-grid/grid-model/grid-config.model';
import { API_ENDPOINTS } from '../../shared/constants/apiEnpoints';
import { DynamicGridComponent } from '../../shared/dynamic-grid/dynamic-grid.component';
import { Toast, ToastComponent } from '../../shared/toast/toast.component';

@Component({
  selector: 'app-backup-monitor',
  templateUrl: './backup-monitor.component.html',
  styleUrls: ['./backup-monitor.component.scss']
})
export class BackupMonitorComponent implements OnInit, AfterViewInit {
  @ViewChild(DynamicGridComponent) dynamicGrid!: DynamicGridComponent;
  @ViewChild(ToastComponent) toastComponent!: ToastComponent;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.dynamicGrid) {
        this.dynamicGrid.fetchData().then(() => {
          this.dynamicGrid.visibleColumns = new Set(this.gridConfig.columns.map(c => c.jsonKey));
          this.changeDetectorRef.detectChanges();
        });
      }
    }, 100);
  }

  gridConfig: GridConfig = {
    columns: [
      { label: 'Backup ID', jsonKey: 'backupId', dataType: 'string', isSortable: true },
      { label: 'Backup Date', jsonKey: 'backupDate', dataType: 'date', isSortable: true },
      { label: 'Database Name', jsonKey: 'databaseName', dataType: 'string', isSortable: true },
      { label: 'Schema Name', jsonKey: 'schemaName', dataType: 'string', isSortable: true },
      { label: 'Tables Backed Up', jsonKey: 'tablesBackedUp', dataType: 'number', isSortable: true },
      { label: 'Status', jsonKey: 'status', dataType: 'string', isSortable: true },
      { label: 'Duration (Seconds)', jsonKey: 'durationSeconds', dataType: 'number', isSortable: true },
      { label: 'Error Message', jsonKey: 'errorMessage', dataType: 'string', isSortable: false }
    ],
    filters: [
      { 
        label: 'Status', 
        jsonKey: 'status', 
        options: { 
          data: [
            { id: 'All', name: 'All Status', checked: true },
            { id: 'SUCCESS', name: 'Success' },
            { id: 'FAILED', name: 'Failed' },
            { id: 'IN_PROGRESS', name: 'In Progress' }
          ] 
        }, 
        type: 'multi' 
      }
    ],
    editable: false,
    deletable: false,
    exportable: true,
    showAllPagination: true,
    uniqueTableName: 'BackupMonitor'
  };

  getDataUrl = API_ENDPOINTS.BACKUP_MONITOR;

  refreshHandler(): void {
    if (this.dynamicGrid) {
      this.dynamicGrid.fetchData();
      this.changeDetectorRef.detectChanges();
    }
  }

  showToast(toast: Toast): void {
    if (this.toastComponent) {
      this.toastComponent.showToast(toast);
      this.refreshHandler();
    }
  }
}